import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NGXLogger } from "ngx-logger";
/// <reference types="@types/googlemaps" />

@Injectable()
export class GoogleMapsAddressService {

    private readonly autocompleteService = new google.maps.places.AutocompleteService();
    private readonly placesService: google.maps.places.PlacesService;

    constructor(
        private readonly logger: NGXLogger,
        private readonly translate: TranslateService) {
        this.placesService = new google.maps.places.PlacesService(document.createElement("div"));
    }

    async loadPredictions(countryIso2: string, term: string, lang: string = this.getLanguageCode()): Promise<google.maps.places.AutocompletePrediction[]> {

        const autocompleteResponse = await this.autocompleteService.getPlacePredictions({
            language: lang,
            input: term,
            componentRestrictions: { country: countryIso2 },
            types: ["address"]
        });

        return autocompleteResponse.predictions;
    }

    async fetchPlace(place_id: string, lang: string = this.getLanguageCode()): Promise<google.maps.places.PlaceResult> {

        let place: google.maps.places.PlaceResult = null;

        try {
            place = await new Promise((resolve, reject) => {
                this.placesService.getDetails({
                    language: lang,
                    placeId: place_id,
                    fields: ["address_components", "formatted_address"]
                }, (place: google.maps.places.PlaceResult, status: google.maps.places.PlacesServiceStatus) => {
                    if (status !== google.maps.places.PlacesServiceStatus.OK || !place?.address_components || !place.formatted_address) {
                        reject(new Error(status));
                    }
                    place.place_id = place_id;
                    resolve(place);
                });
            });
        } catch (e) {
            this.logger.debug("Google Places getDetails failed", e);
        }

        return place;
    }

    private getLanguageCode(): string {
        const angularLang = this.translate.getCurrentLang();
        return angularLang == 'en' ? 'en-GB' : angularLang;
    }
}
